import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'
export default {
  getUserInfo (callback, params) {
    let queryParam = '?'
    queryParam += 'custom_token=' + params.shappyCustomToken
    queryParam += '&app_id=' + params.appId
    queryParam += '&channel_id=' + params.channelId

    HTTP.get(params.token + '/shappy/info' + queryParam).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getConsentForShappy (callback, param) {
    HTTP.get(param.token + '/shappy/consent?language=' + param.language).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getDefaultPolicyForShappy (callback, param) {
    HTTP.get(param.token + '/shappy/policy?language=' + param.language).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/shappy/index.js